import * as Actions from "../Actions/MigrarCadastroActions";

const initialState = {
    info: null,
    warning: null,
    error: null,
};

const MigrarCadastroReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.MIGRARCADASTRO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.MIGRARCADASTRO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.MIGRARCADASTRO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

export default MigrarCadastroReducer;
